<template>
    <b-modal
        hide-footer
        id="axle-weight-calculator"
        title="Axle Weight"
        v-model="visible"
        size="md"
    >
        <ul>
            <li>Rear: Tractor weight x 60% + implement weight</li>
            <li>Front: Tractor weight x 40%</li>
        </ul>

        <b-form-group label="Tractor Weight" :label-cols="12" :label-cols-sm="4">
            <b-input v-model="formTractorWeight" />
        </b-form-group>

        <b-form-group label="Implement Weight" :label-cols="12" :label-cols-sm="4">
            <b-input v-model="formImplementWeight" />
        </b-form-group>

        <b-button
            block
            v-if="frontAxleWeight > 0"
            variant="outline-primary"
            @click="use(frontAxleWeight)"
        >
            Use Front Axle Weight of {{ frontAxleWeight }}
        </b-button>

        <b-button
            block
            v-if="rearAxleWeight > 0"
            variant="outline-primary"
            @click="use(rearAxleWeight)"
        >
            Use Rear Axle Weight of {{ rearAxleWeight }}
        </b-button>

    </b-modal>
</template>

<script>
import _ from 'lodash'

export default {
    data: () => ({
        visible: false,
        type: null,
        formTractorWeight: null,
        formImplementWeight: null,
    }),
    computed: {
        tractorWeight () {
            let value = _.toString(this.formTractorWeight).replace(/[^\d.-]/g, '')
            return _.toSafeInteger(value)
        },
        implementWeight () {
            let value = _.toString(this.formImplementWeight).replace(/[^\d.-]/g, '')
            return _.toSafeInteger(value)
        },
        rearAxleWeight () {
            if (this.tractorWeight <= 0) {
                return
            }
            return _.round((this.tractorWeight * 0.6) + this.implementWeight)
        },
        frontAxleWeight () {
            if (this.tractorWeight <= 0) {
                return
            }
            return _.round(this.tractorWeight * 0.4)
        },
    },
    methods: {
        use (weight) {
            this.$emit('calculated', weight)
            this.visible = false
        },
    },
}
</script>
